export default {
  appTitle: 'Providers web',
  title: 'Authorizations',
  filterLabel: 'Filter by',
  orderLabel: 'Order by',
  authorizationTabLabel: 'Authorizations',
  loadingDataLabel: 'Loading authorizations',
  emptyDataLabel: 'No results found',
  tryAgainLabel: 'Try again with another term or',
  paginationSizeLabel: 'Results/page',
  addAuthorization: 'New authorization',
  addAuthorizationShortLabel: 'New',
  resultLabel: '{result} result | {result} results',
  lastUpdateLabel: 'Last update: {datetime}',
  cleanFilters: 'clean the filters',
  filtersAppliedLabel: 'applied',
  documentation: {
    complete: "Complete",
    incomplete: "({uploaded}/{total}) Docs"
  },
  createAuthorization: {
    success: 'The authorization was created successfully.',
    error: 'An error occurred when creating the authorization.'
  },
  filters: {
    status: 'Status',
    from: 'From',
    to: 'To',
    dateRange: 'Date range',
    searchCode: 'Search authorization or claim',
    satisfiesDocumentsPolicy: 'Documentation'
  },
  order: {
    createdAt: 'Creation date',
    beneficiaryName: 'Beneficiary name (a-z)',
    coverageType: 'Coverage (a-z)',
    status: 'Status'
  },
  authorizationGrid: {
    claimId: 'Claim',
    authorizationCode: "Authorization",
    code: 'Authorization ID',
    createdAt: 'Creation date',
    sponsor: 'Insurer',
    beneficiary: 'Insured',
    memberCode: 'Card',
    authorizationType: 'Authorization type',
    documentation: "Documentation",
    status: 'Status',
    providerBranchName: 'Provider Branch'
  },
  status: {
    error: {
      title: 'Error',
      description: 'Something within the authorization went wrong'
    },
    paid: {
      title: 'Paid',
      description: 'Authorization paid'
    },
    voided: {
      title: 'Voided',
      description: 'Authorization voided'
    },
    expired: {
      title: 'Expired',
      description: 'The lifetime of the authorization has expired'
    },
    canceled: {
      title: 'Canceled',
      description: 'Authorization canceled'
    },
    completed: {
      title: 'Completed',
      description: 'Authorization completed successfully'
    },
    inProgress: {
      title: 'In progress',
      description: 'Processes are underway to complete clearance'
    },
    failed: {
      title: 'Failed',
      description: 'Authorization failed'
    },
    ready: {
      title: 'Ready',
      description: 'Authorization was successful'
    },
    expirationInProgress: {
      title: 'Expiration in progress',
      description: 'Processes are underway to expire the authorization'
    },
    updateInProgress: {
      title: 'update in progress',
      description: 'Processes are underway to update the authorization'
    }
  },
  statusDescription: {
    title: "Filter by status",
    apply: "Apply"
  },
  types: {
    pharmacy: 'Pharmacy',
    process: 'Process',
    prescriptionDrugs: 'Drugs',
    diagnosticTest: 'Diagnostic test',
    sports: 'Sports',
    wellness: 'Wellness',
    education: 'Education',
    creditCardBalance: 'Debit balance',
    occupationalHazard: 'Occupational hazard'
  },
  tabs: {
    authorizations: 'Authorizations',
    NewAuthorization: 'New authorization',
    settlements: 'Settlements',
     newSettlement: 'New settlement'
  },
  actions: {
    void: 'Cancel',
    voidOnlyClaim: 'Cancel claim'
  },
  satisfiesDocumentsPolicy: {
    complete: 'Complete',
    incomplete: 'Incomplete'
  }
}
